import request from "@/utils/request";
export function getLogin(data) {
    return request({
        url: "/login",
        method: "post",
        headers: { secret: false, tag: "YSMF" },
        data,
    });
}
// 退出
export function getLogout(params) {
    return request({
        url: "/logout",
        method: "get",
        headers: { secret: false },
        params,
    });
}
// 检查账号是否注册
export function inspectAccountapi(data) {
    return request({
        url: "/get_mobile",
        method: "post",
        headers: { secret: false },
        data,
    });
}
// 短信登陆
export function getsmsLogin(data) {
    return request({
        url: "/sms_login",
        method: "post",
        headers: { secret: false, tag: "YSMF" },
        data,
    });
}
// 获取管理员信息
export function getUserInfo(params) {
    return request({
        url: "/account/read",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// aes校验
export function Aespost(params) {
    return request({
        url: "/api/aes",
        method: "GET",
        headers: { secret: false },
        params,
    });
}
// 获取菜单
export function getGlobalMenu(params) {
    return request({
        url: "/menu/getGlobalMenu",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 获取邀请列表
export function getInviteapi(params) {
    return request({
        url: "/invite",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 查看管理员
export function getAccount(params) {
    return request({
        url: "/account",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 添加管理员
export function postAccount(data) {
    return request({
        url: "/account",
        method: "post",
        headers: { secret: true },
        data,
    });
}
// 修改管理员用户名
export function putAccount(data) {
    return request({
        url: `/account/${data.id}`,
        headers: { secret: true },
        method: "put",
        data,
    });
}
// 删除管理员
export function deleteAccount(data) {
    return request({
        url: `/account/${data.id}`,
        method: "delete",
        headers: { secret: true },
        data,
    });
}
// 获取用户组
export function getRule(params) {
    return request({
        url: "/rule",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 添加用户组
export function addRule(params) {
    return request({
        url: "/rule",
        method: "post",
        headers: { secret: true },
        params,
    });
}
// 编辑用户组
export function EditRule(params) {
    return request({
        url: `/rule/${params.id}`,
        method: "put",
        headers: { secret: true },
        params,
    });
}
// 获取用户组id和title
export function getRuleTags(params) {
    return request({
        url: "/rule/tags",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 删除用户组
export function deleteRule(data) {
    return request({
        url: `/rule/${data.id}`,
        method: "delete",
        headers: { secret: true },
        data,
    });
}
// 获取验证码
export function postsmssendApi(data) {
    return request({
        url: "/sms_send",
        headers: { secret: false },
        method: "post",
        data,
    });
}
// 验证原手机号
export function postverifymobileApi(data) {
    return request({
        url: "/verify_mobile",
        headers: { secret: true },
        method: "post",
        data,
    });
}
// 修改手机号
export function postsavemobileApi(data) {
    return request({
        url: "/save_mobile",
        headers: { secret: true },
        method: "post",
        data,
    });
}
// 修改密码
export function posteditpwdApi(data) {
    return request({
        url: "/save_password",
        headers: { secret: false },
        method: "post",
        data,
    });
}
export function postUpdatepwdApi(data) {
    return request({
        url: "/account/update_pwd",
        headers: { secret: false },
        method: "post",
        data,
    });
}
// 编辑昵称
export function posteditnameApi(data) {
    return request({
        url: "/save_nickname",
        headers: { secret: true },
        method: "post",
        data,
    });
}
export function register(data) {
    return request({
        url: "/register",
        method: "post",
        data,
    });
}
